import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

const TeamSection = styled.section`
  padding: 5rem 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: ${(props) => props.theme.fontSizes.xxlarge};
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 1rem;
  font-weight: 700;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: ${(props) => props.theme.colors.gray};
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const TeamWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const TeamGrid = styled.div.attrs((props) => ({
  style: {
    animationDuration: `${28}s`,
  },
  "data-item-count": props.itemCount,
}))`
  display: flex;
  gap: 2rem;
  padding: 1rem 0;
  width: fit-content;

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(
        calc(
          -250px * ${(props) => props.itemCount} - 2rem * ${(props) => props.itemCount}
        )
      );
    }
  }

  animation: scroll 28s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const TeamMemberCard = styled.div`
  justify-items: center;
  flex: 0 0 auto;
  width: 250px;
  text-align: center; // Add this line
  display: flex; // Add this line
  flex-direction: column; // Add this line
  align-items: center; // Add this line
`;

const MemberImage = styled.img`
  width: 13rem;
  height: 200px;
  border-radius: 50%;
  object-fit: contain;
  margin-bottom: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  @media (max-width: 768px) {
    height: 160px;
  }
  &:hover {
    transform: scale(1.05);
  }
`;

const MemberName = styled.h3`
  font-size: ${(props) => props.theme.fontSizes.large};
  color: ${(props) => props.theme.colors.dark};
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const MemberRole = styled.p`
  color: ${(props) => props.theme.colors.primary};
  font-size: ${(props) => props.theme.fontSizes.medium};
  margin-bottom: 1rem;
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const SocialLink = styled.a`
  color: ${(props) => props.theme.colors.gray};
  font-size: 1.2rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Team = () => {
  const teamMembers = [
    {
      name: "Mohamed Amzil",
      position: "General Director",
      image: "/images/profiles/amzil.webp",
      linkedin: "https://www.linkedin.com/in/mohamed-amzil-95b7761b8",
      twitter: "#",
    },
    {
      name: "Abdelmalek Youssefi",
      position: "Director of SM Marketing & Press Relations",
      image: "/images/profiles/abdelmalek.webp",
      linkedin: "https://www.linkedin.com/in/abdelmalk-youssefi-76b2b0172",
      twitter: "#",
    },
    {
      name: "Fatima Zahra Saber",
      position: "Human Resources Director",
      image: "/images/profiles/fatima-zahra-saber.webp",
      linkedin: "#",
      twitter: "#",
    },
    //fatema zahra cabli
    {
      name: "Fatema Zahra Cabli",
      position: "Director of Organization Department",
      image: "/images/profiles/fatema-zahra-cabli.webp",
      linkedin: "https://www.linkedin.com/in/fatima-zahra-cabli-43894a203/",
      twitter: "#",
    },
    {
      name: "Zaineb Ahssine",
      position: "General Coordinator of the Association",
      image: `${process.env.PUBLIC_URL}/images/profiles/zineb-ahssine.webp`,
      linkedin: "#",
      twitter: "#",
    },
    {
      name: "Khaoula Bellame",
      position: "Director of the Medical Department",
      image: "/images/profiles/khaoula-bellame.webp",
      linkedin: "#",
      twitter: "#",
    },
    {
      name: "Kawtar Zaddoug",
      position: "Monitoring Manager",
      image: "/images/profiles/kawtar-zaddoug.webp",
      linkedin: "#",
      twitter: "#",
    },
    {
      name: "Salma Alichar",
      position: "Director of Purchasing",
      image: "/images/profiles/salma.webp",
      linkedin: "https://www.linkedin.com/in/salma-alichar-99569a234",
      twitter: "#",
    },
    {
      name: "Oumaima Eddibi",
      position:
        "Director of Logistics",
      image: "/images/profiles/oumaima.webp",
      linkedin: "https://www.linkedin.com/in/oumaima-eddibi-7473191ba",
      twitter: "#",
    },
    {
      name: "Lahcen Lakmale",
      position: "Director of Production Department",
      image: "/images/profiles/lahcen-lakmale.webp",
    },
    {
      name: "Oumaima Ennajib",
      position: "Director of Organization Department",
      image: `${process.env.PUBLIC_URL}/images/profiles/ennajib-opt.webp`,
      linkedin: "https://www.linkedin.com/in/oumaima-ennajib-7473191ba",
      twitter: "#",
    },
    {
      name: "Narjisse El-hillali",
      position: "Director of the Health Department",
      image: `${process.env.PUBLIC_URL}/images/profiles/narjiss.webp`,
      linkedin: "https://www.linkedin.com/in/narjisse-el-hillali-7778001a4",
      twitter: "#",
    },
    {
      name: "Hamza Oubahim",
      position: "Director of the IT Department",
      image: `${process.env.PUBLIC_URL}/images/profiles/hamza.webp`,
      linkedin: "https://www.linkedin.com/in/hamza-oubahim-185ba4151/",
      twitter: "#",
    },
    {
      name: "Youssef Lafkih ",
      position: "Director of the IT Department",
      image: `${process.env.PUBLIC_URL}/images/profiles/youssef.webp`,
      linkedin: "https://www.linkedin.com/in/youssef-lafkih-8130021a0",
      twitter: "#",
    }
    // {
    //   name: "Lahcen Lakmale ",
    //   position: "Director of Production Department",
    //   image: "/images/profiles/lahcen.png",
    //   linkedin: "https://www.linkedin.com/in/lahcen-lakmale-8130021a0",
    //   twitter: "#",
    // },
  ];

  return (
    <TeamSection id="team">
      <Container>
        <SectionTitle>Our Team</SectionTitle>
        <SectionSubtitle>
          Meet the passionate individuals behind our success
        </SectionSubtitle>
        <TeamWrapper>
          <TeamGrid itemCount={teamMembers.length}>
            {[
              ...teamMembers,
              ...teamMembers,
              ...teamMembers,
              ...teamMembers,
            ].map((member, index) => (
              <TeamMemberCard key={index}>
                <MemberImage src={member.image} alt={member.name} width="208" height="200" loading="lazy" />
                <MemberName>{member.name}</MemberName>
                <MemberRole>{member.position}</MemberRole>
                <SocialLinks>
                  <SocialLink
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedin} />
                  </SocialLink>
                  {/* <SocialLink
                    href={member.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                  </SocialLink> */}
                </SocialLinks>
              </TeamMemberCard>
            ))}
          </TeamGrid>
        </TeamWrapper>
      </Container>
    </TeamSection>
  );
};

export default Team;
